import Alert from "@/components/ui/alert";
import { Toaster } from "@/components/ui/toaster";
import { ApolloProvider } from "@/lib/apollo/ApolloProvider";
import { captureException } from "@sentry/react";
import UnverifiedEmail from "./-unverified_email";

const EMAIL_NOT_VERIFIED_ERROR = "email not verified.";

interface Props {
  error: Error;
}

const RootError = ({ error }: Props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const errType = urlParams.get("error") || "Error";
  const errMsg =
    urlParams.get("error_description") || error.message || "Unknown error";

  if (errMsg.includes(EMAIL_NOT_VERIFIED_ERROR)) {
    return (
      <ApolloProvider>
        <UnverifiedEmail errorMsg={errMsg} />;
        <Toaster />
      </ApolloProvider>
    );
  }

  captureException(error);
  return (
    <div className="flex w-full h-screen items-center justify-center">
      <Alert
        className="w-96"
        title={errType}
        description={errMsg}
        variant="default"
      />
    </div>
  );
};

export default RootError;
